import {TranslatePipe} from "@ngx-translate/core";
import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
  selector: 'sf-users-review',
  templateUrl: './users-review.component.html',
  styleUrl: './users-review.component.scss',
  imports: [
    TranslatePipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UsersReviewComponent {

}
